import axios from '../shared/axios';
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function saveCompensationEvent(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/CompensationEvent/SaveCompensationEvent`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'CREATE':
                        events.onNotification_CREATED();
                        break;
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function saveCompensationEarlyWarning(data) {
    return axios.post(`/api/CompensationEvent/SaveCompensationEventEarlyWarning`, data);
}
export function deleteCompensationEarlyWarning(compensationeventid, earlywarningid) {
    return axios.delete(`/api/CompensationEvent/DeleteCompensationEventEarlyWarning?compensationeventid=${compensationeventid}&earlywarningid=${earlywarningid}`);
}


export function saveCompensationEventActivity(data) {
    //THIS EP PATH SAYS /SaveQuotationActivity, But in practice it Saves CompensationEventActivity
    return axios.post(`/api/CompensationEvent/SaveQuotationActivity`, data);
}

export function getCompensationEventActivities(companyid, projectid, contractid, compensationeventid, actionType) {
    return axios.post(`/api/CompensationEvent/LoadCompensationEventActivitiesList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&compensationeventid=${compensationeventid}&actiontype=${actionType}`);
}

export function getCompensationWarnings(companyid, projectid, contractid, compensationeventid) {
    return axios.post(`/api/CompensationEvent/LoadCompensationEventEarlyWarningList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&compensationeventid=${compensationeventid}`);
}

export function getCompensationEvent(compensationeventid) {
    return axios.get(`/api/CompensationEvent/GetCompensationEvent?compensationeventid=${compensationeventid}`);
}

// export function getContractCompansationEvents(companyid, projectid, contractid, source, startdate, enddate, accessibleWfIds) {
//     return axios.post(`/api/CompensationEvent/LoadCompensationEventsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, source, startdate, enddate } });
// }

export function getCompansationEventsReduced(companyid, projectid, contractid, type, accessibleWfIds) {
    const startdate = '', enddate = '';
    if (type == null) { type = '' }
    return axios.post(`/api/CompensationEvent/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, source: type, startdate, enddate } });
}
export function getCompansationEventsReduced2(companyid, projectid, contractid, source, showDrafts, accessibleWfIds) {
    return axios.post(`/api/CompensationEvent/RegisterListV2`, {
        showDrafts: showDrafts,
        showRelations: process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true',
        showTags: process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true',
        showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
        excludeTagHeaders: true,
        accessibleWfIds
    },
        {
            params: {
                companyid,
                projectid,
                contractid,
                source,
                startdate: '',
                enddate: ''
            }
        });
}

export function getCompansationEventsToSelectList(contractid, statuses) {
    return axios.post(`/api/CompensationEvent/ToSelectList`, { contractid, statuses });
}

export function deleteCompensationEventDraft(compensationeventid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/CompensationEvent/DeleteDraft?compensationeventid=${compensationeventid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importCompensationEvents(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/CompensationEvent/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteCompensationEventDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/CompensationEvent/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateCompensationEventDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/CompensationEvent/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}